import React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { Card, Text, Button, Flex } from '../../design-system';
import YoutubeEmbed from '../../components/YoutubeEmbed';
const FormContainer = styled(Flex)`
  width: 100%;
  align-items: center;
  justify-content: center;
`;

const UserCard = styled(Card)`
  min-width: 900px;
`;

const FirstWelcome = () => {
  const onBulkDataSubmit = () => {
    const win = window.open(
      'https://www.grantholster.com/migrating-your-data',
      '_blank',
    );
    win?.focus();
  };

  return (
    <FormContainer mt={35}>
      <UserCard p={30} pt={0}>
        <Card.Header textAlign="center">
          <Text fontSize={18}>You're all done! Welcome to Grant Holster!</Text>
          <br />
          <Text fontSize={18} fontWeight="normal">
            Here's some optional next steps . . .
          </Text>
        </Card.Header>

        <Card.Body mt={10} textAlign="center">
          <Flex mb={2} mt={2} flexDirection="column" justifyContent="center">
            <Text>
              1. Check out our tutorial video (recommended!) <br />
            </Text>
          </Flex>
          <YoutubeEmbed embedId="TRp3u7KAHNs?si=7oqNVy7d99_IlXQh" />
          <Flex mb={2} mt={2} flexDirection="column" justifyContent="center">
            <Text>2. Get all your data migrated over</Text>
          </Flex>
          <Flex mt={2} flexDirection="column" justifyContent="center">
            <Flex flexDirection="row" justifyContent="center">
              <Button onClick={onBulkDataSubmit}>Migrate your Data</Button>
            </Flex>
            <Text mt={1} mb={1}>
              or . . .
            </Text>
            <Flex flexDirection="row" justifyContent="center">
              <Link to="/dashboard">
                <Button>Let's just get started!</Button>
              </Link>
            </Flex>
          </Flex>
        </Card.Body>
      </UserCard>
    </FormContainer>
  );
};

export default FirstWelcome;
